import './button.styles.scss';
import { Link } from 'react-router-dom';

const Button = ({ btnText }) => {
  return (
    <Link className='button-container' to={'/'}>
      {btnText}
    </Link>
  );
};

export default Button;
